/**
 * Schermteksten in het Oekraïens.
 *
 * GEMAAKT DOOR EEN MACHINE uit teksten/nl.ts, met
 * server/scripts/vertaal-teksten.ts. Niet met de hand bijwerken: een
 * volgende ronde overschrijft het.
 *
 * Machinevertaling van een interface is een START. Knoppen zijn kort en
 * zonder context, en juist daar gaat het mis. Laat dit nakijken door
 * iemand die de taal spreekt voordat het naar echte gebruikers gaat.
 */
import type { Teksten } from './nl';

export const uk: Teksten = {
  kamerOphalen: "Отримання кімнати…",
  kamerWerktNiet: "Ця кімната не працює",
  serverReageertNiet: "Сервер не відповідає",
  probeerOpnieuw: "Спробуй знову",
  vraagNieuweCode: "Попроси новий код у того, хто ним поділився. Кімната закривається за кілька годин.",
  welkeTaalSprekJij: "Якою мовою ти розмовляєш?",
  jouwStem: "Твій голос у перекладі",
  man: "Чоловік",
  vrouw: "Жінка",
  pincode: "Пін-код",
  pincodeUitleg: "Його тобі надасть той, хто поділився кодом.",
  gaDeKamerIn: "Увійти в кімнату",
  kiesEerstJeTaal: "Спочатку вибери мову",
  microfoonAanvragen: "Запит мікрофона…",
  toestemmingUitleg: "Твій браузер зараз запитає дозвіл на використання мікрофона. Без нього ти зможеш лише писати.",
  microfoonTestLink: "Спочатку перевір мікрофон",
  stemGaatMee: "У цій кімнаті інший учасник також чутиме твій власний голос, окрім перекладу.",
  alleenChatMelding: "Ця розмова — лише чат. Ти пишеш повідомлення й читаєш переклад; нічого не зачитується вголос.",
  verlooptOm: "Дійсна до",
  nooitVasteKamer: "Ніколи, постійна кімната",
  kamer: "Кімната",
  tolkgesprek: "Переклад розмови",
  juisteKamer: "Ти у потрібній кімнаті. За мить ти зможеш приєднатися до розмови.",
  jij: "ти",
  deAnder: "співрозмовник",
  verbinden: "З'єднання…",
  verbonden: "З'єднано",
  verbindingKwijt: "Зв'язок втрачено. Повторна спроба…",
  wachtenOpAnder: "Ти всередині. Зачекай, поки інший учасник відсканує QR-код.",
  allebeiInDeKamer: "Ви обоє в кімнаті.",
  anderIsWeg: "Співрозмовник вийшов",
  anderSpreekt: "Співрозмовник говорить…",
  jeKuntErNietIn: "Ти не можеш увійти",
  overgenomenTitel: "Продовжено на іншому пристрої",
  overgenomenUitleg: "Цю розмову щойно відкрили на іншому пристрої. Спілкування продовжується там.",
  terug: "Назад",
  geluidStaatUit: "Звук вимкнено. Торкнись екрана в будь-якому місці.",
  tikHier: "торкнись тут",
  bewaardTot: 'Зберігається до {tijd}',
  bewaardVast: "Постійна кімната. Повідомлення зберігаються 30 днів.",
  spreekIn: "Говори",
  luisteren: "Слухаю… торкнись, щоб зупинити",
  uitschrijven: "Розкодування…",
  tijdOmTeVerbeteren: "Час на виправлення",
  altijdZelfVersturen: "Завжди перевіряти та надсилати самостійно",
  jijVerstuurtZelf: "Надсилаєш самостійно",
  uit: "вимк.",
  sec: "сек",
  vertalingMeteenAfspelen: "Відтворювати переклад одразу",
  typHierJeBericht: "Напиши повідомлення…",
  stuur: "Надіслати",
  geenOpnameMogelijk: "Цей браузер не може записувати аудіо. Але ти можеш писати.",
  verstaanAls: "Розпізнано як",
  tellerStaatStil: "таймер зупинено",
  versturen: "Надіслати",
  wis: "Очистити",
  jijZei: "ти сказав",
  vertaald: "перекладено",
  duimOmhoog: "Це правильно",
  duimOmlaag: "Це неправильно",
  opnieuwProberenKnop: "Спробувати знову з кращою моделлю",
  opnieuwProberenBezig: "Перекладаю знову…",
  duimTranscriptWoordenlijstUitnodiging: "Неправильно розпізнано? Виправ це у словнику:",
  instellingenAanpassen: "Змінити налаштування",
  geldtVoorJullieBeiden: "Діє для вас обох",
  alleenVoorJou: "Лише для тебе",
  stuurMijnStemMee: "Передавати мій голос",
  verbeterSpelfouten: "Виправляти орфографічні помилки у моєму тексті",
  verbeterSpelfoutenUit: "Вимкнення покаже все саме так, як було розпізнано, з помилками включно.",
  alleenChat: "Лише чат: без голосу, без мікрофона",
  alleenChatUitleg: "Ви обоє пишете. Показуються переклад і оригінальний текст; нічого не зачитується вголос.",
  aangepastDoorDeAnder: "Співрозмовник змінив налаштування.",
  foutSpraak: "Переклад готовий, але озвучити його не вдалося.",
  foutSpraakQuota: "Ліміт на озвучення на сьогодні вичерпано. Текст працює як зазвичай; озвучення повернеться завтра.",
  foutBudgetKamer: "Ця розмова досягла свого ліміту, тому переклад призупинено. Той, хто її створив, може його збільшити — після цього все одразу знову працюватиме.",
  foutBudgetMaand: "Місячний бюджет застосунку вичерпано. Переклад знову працюватиме, коли адміністратор його змінить.",
  foutTaal: "Ця мова недоступна: ви обоє розмовляли б однією мовою.",
  origineel: "оригінал",
  vertalen: "Переклад…",
  vertalenMislukt: "Не вдалося перекласти.",
  opnieuwAfspelen: "Прослухати переклад знову",
  hoorDeAnder: "Послухай, як це сказав співрозмовник",
  woordenlijst: "Словник виправлень",
  woordenlijstUitleg: "Додаток постійно неправильно розпізнає ім'я чи термін? Запиши тут правильний варіант.",
  hijHoort: "він чує…",
  jijBedoelt: "ти маєш на увазі…",
  ookVolgendeGesprekken: "Також у наступних розмовах — інакше діє лише тут",
  voegToe: "Додати",
  bezig: "Обробока…",
  lijstNietGeladen: "Не вдалося завантажити список.",
  toevoegenMislukt: "Не вдалося додати.",
  verwijderenMislukt: "Не вдалося видалити.",
  overal: "усюди",
  verwijder: "Видалити",
  overDitGesprek: "Про цю розмову",
  toon: "Тон перекладу",
  sfeer: "Атмосфера розмови",
  jouwPlek: "Твоє розташування",
  hoeHetWerkt: "Сервер розкодовує твій запис і перекладає його за один раз. Твій власний голос передається співрозмовнику.",
  kleinereTekst: "Менший текст",
  grotereTekst: "Більший текст",
  insprekenVerbergen: "Приховати голосове введення",
  insprekenTonen: "Показати голосове введення",
  toetsenbordVerbergen: "Приховати клавіатуру",
  toetsenbordTonen: "Показати клавіатуру",
  vormAutomatisch: "Автоматично",
  vormInformeel: "Неформальний (на ти)",
  vormFormeel: "Формальний (на Ви)",
  sfeerNeutraal: "Нейтральна",
  sfeerZakelijk: "Ділова",
  sfeerOfficieel: "Офіційна",
  sfeerVriendschappelijk: "Дружня",
  sfeerPartner: "Партнерська",
  foutKamerVol: "Ця кімната заповнена. У ній можуть перебувати лише двоє людей.",
  plekBezetTitel: "Твоє місце зайняте",
  plekBezetUitleg: "На твоєму боці цієї розмови вже хтось є, твоєю мовою. Зазвичай це ти сам: розмова ще відкрита на іншому пристрої або в іншій вкладці. Закрий її там і спробуй знову. Іноді місце звільняється лише за півтори хвилини.",
  plekBezetWissel: "Це ти? Введи WISSEL, щоб перенести розмову на цей пристрій. Інший пристрій тоді закриється.",
  plekBezetKnop: "Перенести на цей пристрій",
  foutKamerVerlopen: "Термін дії цієї кімнати закінчився або її закрили.",
  foutKamerOnbekend: "Цієї кімнати не існує.",
  foutPinNodig: "Для цієї кімнати потрібен пін-код.",
  foutPinFout: "Неправильний пін-код.",
  foutProtocol: "Додаток і сервер не розуміють один одного. Онови сторінку.",
  foutMicroGeweigerd: "Доступ до мікрофона відхилено. Натисни на значок замка в адресному рядку та увімкни його.",
  foutGeenMicro: "Мікрофон не знайдено. Підключи його та спробуй знову.",
  foutMicroInGebruik: "Мікрофон використовується іншою програмою. Закрий її та спробуй знову.",
  foutGeenHttps: "Мікрофон працює лише через безпечне з'єднання. Відкрий цю сторінку через https.",
  foutMicroOnbekend: "Не вдалося запустити мікрофон.",
  foutNietsOpgenomen: "Нічого не записано. Твій мікрофон увімкнено?",
  foutNietsGehoord: "Нічого не чути. Чи увімкнено мікрофон і чи достатньо голосно ти говориш?",
  foutOpnameTeLang: "Запис занадто довгий. Говори коротшими фразами.",
  foutMicroGedempt: "Твій мікрофон вимкнено. Увімкни його та спробуй знову.",

  // --- microfoontest ---
  micTitel: "Перевірка мікрофона",
  micOnderschrift: "Чотири тести поспіль, по п'ять секунд кожен. Говори весь цей час.",
  micStart: "Запустити тест",
  micTest1: "1. Лише розпізнавання",
  micTest2: "2. Лише запис",
  micTest3: "3. Разом — спочатку запис",
  micTest4: "4. Разом — спочатку розпізнавання",
  micFase1: "1 з 4: лише розпізнавання — скажи коротку фразу",
  micFase2: "2 з 4: лише запис — говори далі",
  micFase3: "3 з 4: спочатку запис, потім розпізнавання — говори далі",
  micFase4: "4 з 4: спочатку розпізнавання, потім запис — говори далі",
  micKlaar: "готово",
  micGehoord: "почуто",
  micOpnameformaat: "Формат запису",
  micGeen: "немає",
  micBeveiligd: "Захищене з'єднання",
  micJa: "так",
  micNee: "НІ",
  micBrowser: "Браузер",
  micGeenHttps: "Без https браузер не дасть доступ до мікрофона. На localhost можна.",
  micGeenHerkenning: "У цьому браузері немає розпізнавання мовлення.",
  micZegIets: "скажи щось…",
  micWoordenBinnen: "слова надходять",
  micKonNietStarten: "не вдалося запустити",
  micGeenRecorder: "Цей браузер не знає MediaRecorder.",
  micOpnemen: "триває запис…",
  micNietsOpgenomen: "нічого не записано",
  micGeenMicrofoon: "немає мікрофона",
  micOpnameEerst: "спочатку запис…",
  micHerkenningEerst: "спочатку розпізнавання…",
  micOpnameStarttNiet: "запис не почався",
  micSamenGelukt: "Разом. Запис {kb} кБ.",
  micAlleenOpname: "Запис так, розпізнавання ні.",
  micAlleenHerkenning: "Розпізнавання так, запис ні.",
  micGeenVanBeide: "Ні те, ні інше.",
  micNetwerkFout: "Розпізнавання мовлення не змогло зв’язатися із сервером.",
  micAfgebroken: "Запис було перервано.",
  verslagTitel: "Протокол розмови",
  verslagWie: "Хто",
  verslagOrigineel: "Оригінал",
  verslagVertaling: "Переклад",
  verslagSpreker: "Учасник {x}",
  verslagBerichten: "Повідомлення",
  verslagGemaaktOp: "Створено",
  verslagGeenOpname: "Це не дослівний запис.",
  verslagNootOrigineel: "«Оригінал» — це текст у тому вигляді, в якому застосунок зрозумів мовця.",
  verslagNootCorrectie: "Перевірка правопису була увімкнена: дрібні помилки виправлено.",
  verslagNootAangepast: "Мовець міг змінити текст перед надсиланням.",
  verslagGesproken: "усно",
  verslagGetypt: "набрано",
  verslagMislukt: "Переклад не вдався. Інша сторона не побачила це речення своєю мовою.",
  verslagNietKlaar: "Переклад ще не був готовий, коли створювався цей протокол.",
  verslagVertrouwelijk: "Конфіденційно.",
  verslagAlleenDeelnemers: "Цей протокол містить зміст приватної розмови і призначений лише для її учасників.",
  verslagGewist: "Дата видалення розмови: {tijd}. Після цього протокол не можна буде створити знову.",
  verslagGewistVast: "Постійна кімната: кожне повідомлення видаляється через 30 днів після надсилання. Старіших повідомлень у цьому протоколі немає.",
};
